// hooks/useCreateNewReservation.ts
import { useDispatch } from "react-redux";
import Logger from "../helpers/logger";
import ErrorTracker from "../helpers/errorTracker";
import {
  navigatedToNextStep,
} from "../slice/bookingCreation/bookingCreationSlice";
import { enqueueNotification } from "../slice/notification/notificationSlice";
import { t } from "i18next";
import { baseStore } from "../store";
import { rentalsApiSlice } from "../../api/rentals/rentalsApiSlice";

export const useUpdateOrderFlow = ({
  orderId,
  items,
  state,
  token,
}: {
  orderId: string;
  items: string[];
  state: string;
  // The courier's token from the compartment opening (#3665 H3).
  token?: string;
}) => {
  const dispatch = useDispatch();

  const updateItem = async () => {
    try {
      const data: any = await baseStore.dispatch(
        rentalsApiSlice.endpoints.updateItemState.initiate({
          items,
          orderId,
          state,
          token,
        })
      );

      if (data.error) {
        if (data.error.data.msg.includes("item_placement_confirmed")) {
          dispatch(
            enqueueNotification({
              severity: "error",
              message: t("book_location.parcel_placement.item_already_placed"),
            })
          );
        } else {
          dispatch(
            enqueueNotification({
              severity: "error",
              message: data.error.data?.msg as string,
            })
          );
        }
      } else {
        dispatch(navigatedToNextStep());
      }
    } catch (error) {
      Logger.for("createNewReservation").error(error);
      ErrorTracker.trackException(error as Error);
    }
  };

  return updateItem;
};
